/**
 * Add class "ready" when dom is ready
 */
window.addEventListener('DOMContentLoaded', () => {
	document.body.classList.add('ready');
});

/**
 * Add class "loaded" when site is loaded
 */
window.addEventListener('load', () => {
	document.body.classList.add('loaded');
});